<table class="module-list">
    <thead>
        <tr>
            <th></th>
            <th ng-repeat="module in $ctrl.modules track by module.id"><c-module-icon config="module"></c-module-icon></th>
        </tr>
    </thead>
    <tbody>
        <tr ng-repeat="group in $ctrl.groups track by group.groupId" ng-class="$ctrl.hasChanges(group)">
            <th>{{group.text|translate}}</th>
            <td ng-repeat="module in group.modules track by module.id"><c-checkbox ng-if="module.canChange" checked="module.visible"></c-checkbox></td>
        </tr>
    </tbody>
</table>
